module.exports = __webpack_public_path__ + "img/flag.aba4fbfd.svg";